module.exports = __webpack_public_path__ + "img/logo_footer.c931d578.png";